export const customStyles = {
  // Ensure table never exceeds its container width
  table: {
    style: {
      width: '100%',
      tableLayout: 'fixed',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#172554',
      color: '#FFFFFF',
      fontWeight: 'bold',
      fontSize: '14px',
    },
  },
  headCells: {
    style: {
      paddingLeft: '8px',
      paddingRight: '8px',
      whiteSpace: 'nowrap',
    },
  },
  rows: {
    style: {
      backgroundColor: '#F5F5F5', // Light gray background for rows
      fontSize: '13px',
      '&:hover': {
        backgroundColor: '#E0E0E0', // Darker gray on hover
      },
    },
  },
  cells: {
    style: {
      paddingLeft: '8px',
      paddingRight: '8px',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  },
};